module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Diamond in the Unknown")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#in-the-known"
    }
  }, [_vm._v("1.1: In the Known")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#a-step-towards-unknown"
    }
  }, [_vm._v("1.2: A Step Towards Unknown")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#knowing-the-known"
    }
  }, [_vm._v("2.1: Knowing the Known")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#meeting-the-past"
    }
  }, [_vm._v("2.2: Meeting the Past")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#some-lessons",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.1: Some Lessons")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#in-the-past",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.2: In the Past")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#into-the-unknown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1: Into the Unknown")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#facing-the-reality",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.2: Facing the Reality")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#hate-the-fuel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.1: Hate, The Fuel")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#love-thats-all",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.2: Love, That’s all")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#i-wish-your-wish",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.1: I Wish Your Wish")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#when-evils-meet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.2: When Evils Meet")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#topaz-a-hero",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.1: Topaz, A Hero")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#the-humours-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.2: The Humours Day")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#a-magical-tear",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.1: A Magical Tear")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#fear-or-forward",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.2: Fear or Forward")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#the-first-win",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.1: The First Win")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#fear-o-fear",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.2: Fear O Fear")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#in-the-past-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.1 In the Past")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#a-way-out",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.2: A Way Out")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#love-an-answer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.1: Love an Answer")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#way-forward-in-the-past",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.2: Way Forward in the Past")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#love-wedding-songs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.1: Love, Wedding, Songs")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#plan-after-plan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.2: Plan After Plan")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#the-fight-begins",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.1: The Fight Begins")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#love-and-war",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.2: Love and War")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#attitude-gratitude",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.3: Attitude Gratitude")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246b895e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0